import React, { Component } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OfficeEmployeeCostGroupSettingItem from '../../../Domain/OfficeEmployeeCostGroupSettingItem';
import OfficeService from '../../../Services/OfficeService';

class OfficeEmployeeCostGroupSettingsPanel extends Component
{
    constructor (props)
    {
        super(props);

        this.state = {
            settings: [],
            searchItem: {},
        };

        OfficeEmployeeCostGroupSettingItem.clickOnEdit = this.props.editFunction || (() => { });
    }

    static convertSettings (items)
    {
        const convertedItems = [];
        if (items !== null)
        {
            items.forEach((item) =>
            {
                convertedItems.push(new OfficeEmployeeCostGroupSettingItem(item));
            });
        }
        return convertedItems;
    }

    render ()
    {
        return (
            <div>
                <TabOfDataTable
                    type={OfficeEmployeeCostGroupSettingItem}
                    itemList={this.state.settings}
                    serviceFunction={() => OfficeService.GetOfficeEmployeeCostGroupSettings(this.props.officeId)
                        .then((data) => ({
                            data: data,
                            numberOfElementsInTheTable: data.length,
                        }))
                    }
                    convertDBItemsFunction={OfficeEmployeeCostGroupSettingsPanel.convertSettings}
                    searchItem={this.state.searchItem}
                    orderDirection={OrderDirectionsEnum.Asc}
                    showSearchStrip={false}
                    searchParamsType={null}
                    changeOfItemListFunction={(list) => this.setState({ settings: list })}
                    errorCode='OECGS45'
                    showPagination={false}
                />
            </div>
        );
    }
}

export default OfficeEmployeeCostGroupSettingsPanel;
